module.exports = __webpack_public_path__ + "components/weather-icon/static/daypartcloud-973480e82c9244eb4057b69770a99995.svg";